import type { ReactNode } from "react";

interface Props {
  abierto: boolean;
  titulo: string;
  onCerrar: () => void;
  children: ReactNode;
  acciones?: ReactNode;
}

export function Dialog({ abierto, titulo, onCerrar, children, acciones }: Props) {
  if (!abierto) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4">
      <div className="card w-full max-w-lg max-h-[90vh] flex flex-col">
        <div className="flex items-start justify-between border-b border-slate-200 p-4">
          <h2 className="text-lg font-semibold text-slate-900">{titulo}</h2>
          <button
            type="button"
            onClick={onCerrar}
            className="text-slate-400 hover:text-slate-700 text-xl leading-none"
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
        <div className="flex-1 overflow-auto p-4 space-y-3">{children}</div>
        {acciones && (
          <div className="flex justify-end gap-2 border-t border-slate-200 p-4">
            {acciones}
          </div>
        )}
      </div>
    </div>
  );
}
